import { Multiples, Submultiples } from "../../SIprefixe";
import { Unit, UnitBaseTypes } from "../../Units";

function KiloNewtonDividedByMillimetreSquared() {
  let dividedby = "/";
  return (
    <>
      <Unit unit={UnitBaseTypes.newton} prefix={Multiples.kilo} />
      {dividedby}
      <Unit unit={UnitBaseTypes.metre} prefix={Submultiples.milli} exponent={2} />
    </>
  );
}
export default KiloNewtonDividedByMillimetreSquared;
